import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import {
  requiredFileIf,
  requiredFiles,
} from '../../../useValidateQuestionnaire';

import { IncomeFromTheUsStateValues, updateKey } from './slice';

// predicate:
// 'Displayed in case the user selected "Yes" to the "I have income from the US" question.',

export const fields: IBaseField<keyof IncomeFromTheUsStateValues>[] = [
  {
    name: 'didYouReceiveWagesDuringTheYearFromAUsEmployer',
    label: 'Did you receive wages during the year from a US employer?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadFormW2',
        label: 'Please upload Form W-2',
        type: 'upload',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'areYouAUsGovernmentEmployee',
        label: 'Are you a US government employee?',
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
    ],
  },

  {
    name: 'didYouPerformWorkAsAConsultantOrIndependantContractorForAUsFirm',
    label:
      'Did you perform work as a consultant or independant contractor for a US firm?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadForm1099Misc',
        label: 'Please upload Form 1099-MISC or 1099-NEC',
        type: 'upload',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
      },
    ],
  },

  {
    name: 'didYouReceieveRoyaltiesUnemploymentPaymentsOrOtherMiscellaneousIncomeFromAUsSource',
    label:
      'Did you receieve royalties, unemployment payments or other miscellaneous income from a US source?',
    type: 'radio',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'pleaseUploadACopyOfForm1099MiscOrFormK1',
        label: 'Please upload a copy of form 1099-MISC or form K-1',
        type: 'upload',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
